var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompetedFilledIcon = function SvgCompetedFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.25,
    height: 17.25,
    x: 0.375,
    y: 0.375,
    fill: "currentColor",
    rx: 8.625
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.25,
    height: 17.25,
    x: 0.375,
    y: 0.375,
    stroke: "currentColor",
    strokeWidth: 0.75,
    rx: 8.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.398 6.727c.22.22.22.576 0 .796l-3.75 3.75a.56.56 0 0 1-.796 0l-2.25-2.25a.563.563 0 0 1 .796-.796L8.25 10.08l3.352-3.352c.22-.22.576-.22.796 0",
    clipRule: "evenodd"
  })));
};
export default SvgCompetedFilledIcon;